module.exports = __webpack_public_path__ + "static/img/hitbox-close.2ac54af6.png";